<template>
    <div>
        <el-row :gutter="10">
            <!-- Search -->
            <el-col :xs="12" :sm="12" :md="4" :lg="3" :xl="3">
                <el-input
                    v-model="search"
                    @input="applySearch"
                    placeholder="Type to apply search..."
                    prefix-icon="el-icon-search"
                    clearable
                >
                </el-input>
            </el-col>

            <!-- Type Filter -->
            <el-col :xs="12" :sm="12" :md="4" :lg="3" :xl="3">
                <el-select
                    v-model="bundle_type_filter"
                    @change="changedBundleTypeFilter"
                    class="no-select w-full"
                    placeholder="Select"
                    default-first-option
                    filterable
                >
                    <el-option
                        label="Customer Profiles"
                        :value="ComplianceBundleTypes.CUSTOMER_PROFILE"
                    />
                    <el-option
                        label="Trust Bundles"
                        :value="ComplianceBundleTypes.A2P_TRUST_PRODUCT"
                    />
                    <el-option
                        label="A2P Brands"
                        :value="ComplianceBundleTypes.A2P_BRAND"
                    />
                    <el-option
                        label="A2P Campaigns"
                        :value="ComplianceBundleTypes.A2P_MESSAGING_SERVICE"
                    />
                    <el-option
                        label="STIR/SHAKEN"
                        :value="ComplianceBundleTypes.STIR_SHAKEN"
                    />
                    <el-option
                        label="Voice Integrity"
                        :value="ComplianceBundleTypes.VOICE_INTEGRITY"
                    />
                    <el-option
                        label="Branded Caller ID"
                        :value="ComplianceBundleTypes.BRANDED_CALLER_ID"
                    />
                    <el-option
                        label="CNAM Caller ID"
                        :value="ComplianceBundleTypes.CNAM_BUNDLE"
                    />
                    <el-option
                        label="Verified Caller ID"
                        :value="ComplianceBundleTypes.VERIFIED_CALLER_ID"
                    />
                    <el-option
                        label="Toll-Free Verification"
                        :value="ComplianceBundleTypes.TOLL_FREE_VERIFICATION"
                    />
                    <el-option
                        label="Address"
                        :value="ComplianceBundleTypes.ADDRESS_BUNDLE"
                    />
                    <el-option
                        label="Regulatory Bundle"
                        :value="ComplianceBundleTypes.REGULATORY_BUNDLE"
                    />
                    <el-option
                        label="Twilio Numbers"
                        :value="ComplianceBundleTypes.INCOMING_NUMBER"
                    />
                    <el-option
                        label="RCS"
                        :value="ComplianceBundleTypes.RCS"
                    />
                </el-select>
            </el-col>

            <!-- Top Buttons -->
            <el-col :xs="24" :sm="24" :md="12" :lg="13" :xl="13">
                <el-button
                    type="success"
                    size="medium"
                    icon="el-icon-refresh"
                    @click="syncBundleRemote"
                    :loading="loading_sync_bundle.includes(bundle_type_filter)"
                >
                    Sync
                </el-button>
                <el-button
                    v-if="showEnableReregistrationButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-open"
                    @click="toggleBundleReregistration"
                    :loading="enabling_reregistration"
                >
                    <span v-if="company.kyc_filled">Enable Registration</span>
                    <span v-else>Disable Registration</span>
                </el-button>
                <el-button
                    v-if="showRegisterCustomerProfileButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-edit-outline"
                    @click="onClickCustomerProfileRegistration"
                >
                    Register Customer Profile
                </el-button>
                <el-button
                    v-if="showRegisterA2PTrustProductButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-edit-outline"
                    @click="openregisterA2PTrustProductDialog"
                    :loading="registering_a2p_trust_bundle"
                >
                    Register A2P Trust Product
                </el-button>
                <el-button
                    v-if="showRegisterA2pBrandBundleButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-edit-outline"
                    @click="openRegisterA2pBrandBundleDialog"
                    :loading="registering_a2p_brand_bundle"
                >
                    Register A2P Brand Bundle
                </el-button>
                <el-button
                    v-if="showRegisterStirShakenBundleButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-edit-outline"
                    @click="openRegisterStirShakenBundleDialog"
                    :loading="registering_stir_shaken_bundle"
                >
                    Register STIR/SHAKEN Bundle
                </el-button>
                <el-button
                    v-if="showRegisterVoiceIntegrityBundleButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-edit-outline"
                    @click="openRegisterVoiceIntegrityBundleDialog"
                >
                    Register Voice Integrity Bundle
                </el-button>
                <el-button
                    v-if="showSubmitBrandedCallerIdButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-phone"
                    @click="openSubmitBrandedCallerIdDialog"
                >
                    Submit Branded Caller ID
                </el-button>
                <el-button
                    v-if="showCreateTollFreeVerificationButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-phone-outline"
                    @click="openCreateTollFreeVerificationDialog"
                    :loading="creating_toll_free_verification"
                >
                    Create Toll-Free Verification
                </el-button>
                <el-button
                    v-if="showSyncMaintenanceAddonsButton"
                    type="primary"
                    size="medium"
                    icon="el-icon-refresh"
                    @click="syncMaintenanceAddons"
                    :loading="syncing_maintenance_addons"
                >
                    Sync Chargebee Addons
                </el-button>
                <el-tooltip
                    v-if="showSyncMaintenanceAddonsButton"
                    class="item"
                    effect="dark"
                    placement="bottom"
                >
                    <div slot="content">
                        Use this if the account's subscription is missing required A2P Campaign Maintenance Add-ons. It will add the missing maintenance add-ons in Chargebee for the associated campaigns.
                    </div>
                    <i class="material-icons text-lg cursor-pointer text-blue p-0">info_outline</i>
                </el-tooltip>
            </el-col>

            <!-- Pagination -->
            <el-col class="mt-2">
                <el-pagination
                    layout="sizes, prev, pager, next"
                    :current-page.sync="pagination.page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size.sync="pagination.size"
                    :total="pagination.total"
                    @size-change="paginateBundles(1)"
                    @current-change="paginateBundles"
                >
                </el-pagination>
            </el-col>
        </el-row>
        <hr>

        <!-- Bundle Information -->
        <el-row :gutter="10" class="mt-2">
            <compliance-bundle-information :selectedBundleTypeId="bundle_type_filter"/>
        </el-row>
        <hr>

        <!-- Bundle List -->
        <ComplianceBundleList
            :key="bundle_key"
            :loading-bundles="loading_bundles"
            :bundles="bundles"
            :unregistered_incoming_numbers_count="unregistered_incoming_numbers_count"
            :company="company"
            :type="bundle_type_filter"
            @view-details="handleViewDetails"
            @numbers-assigned="handleNumbersAssigned"
        />

        <!-- Customer Profile Registration Dialog -->
        <CustomerProfileRegistrationDialog
            :visible="customerProfileRegistrationDialogFormVisible"
            :company="company"
            @registered="handleCustomerProfileRegistered"
            @close="closeCustomerProfileRegistrationDialog"
        />

        <!-- A2P Trust Product Dialog -->
        <el-dialog
            title="Submit A2P Trust Product"
            width="60vh"
            :visible.sync="show_register_a2p_trust_bundle_dialog"
            :before-close="handleClose"
        >
            <el-select
                v-model="selected_customer_profile_id"
                class="w-full"
                placeholder="Select customer profile "
                clearable
            >
                <el-option
                    class="p-0"
                    v-for="customer_profile in customer_profiles"
                    :key="customer_profile.id"
                    :value="customer_profile.id"
                    :label="`#${customer_profile.id} - ${customer_profile.sid}`"
                    :disabled="disableCustomerProfileSelection(customer_profile)"
                >
                    <label>#{{ customer_profile.id }} - {{ customer_profile.sid }}</label>
                    <small class="ml-2 text-dark font-weight-bold">
                        <b
                            v-if="customer_profile.status"
                            class="label"
                            :class="customer_profile.status | statusColor"
                        >
                            {{ customer_profile.status_name }}
                        </b>
                    </small>
                </el-option>
            </el-select>
            <div class="row mt-3">
                <div class="col-md-12 text-right">
                    <el-button
                        type="primary"
                        :loading="registering_a2p_trust_bundle"
                        :disabled="!selected_customer_profile_id"
                        @click="registerA2PTrustProduct"
                    >
                        Submit
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- A2P Brand Bundle Dialog -->
        <el-dialog
            title="Submit A2P Brand Bundle"
            width="60vh"
            :visible.sync="show_register_a2p_brand_bundle_dialog"
            :before-close="handleClose"
        >
            <el-select
                v-model="selected_customer_profile_id"
                class="w-full"
                placeholder="Select customer profile "
                clearable
                @change="getA2pProfileBundles(selected_customer_profile_id)"
            >
                <el-option
                    class="p-0"
                    v-for="customer_profile in customer_profiles"
                    :key="customer_profile.id"
                    :value="customer_profile.id"
                    :label="`#${customer_profile.id} - ${customer_profile.sid}`"
                    :disabled="disableCustomerProfileSelection(customer_profile)"
                >
                    <label>#{{ customer_profile.id }} - {{ customer_profile.sid }}</label>
                    <small class="ml-2 text-dark font-weight-bold">
                        <b
                            v-if="customer_profile.status"
                            class="label"
                            :class="customer_profile.status | statusColor"
                        >
                            {{ customer_profile.status_name }}
                        </b>
                    </small>
                </el-option>
            </el-select>
            <el-select
                v-model="selected_a2p_profile_bundle_id"
                :disabled="!selected_customer_profile_id"
                class="w-full mt-4"
                placeholder="Select A2P Trust Product"
                clearable
            >
                <el-tooltip
                    v-for="a2p_trust_product in a2p_trust_products"
                    :key="a2p_trust_product.id"
                    effect="dark"
                    :content="a2p_trust_product_option_tooltip"
                    placement="top"
                    :disabled="!disableA2pTrustBundleSelection(a2p_trust_product)"
                >
                    <el-option
                        class="p-0"
                        :value="a2p_trust_product.id"
                        :label="`#${a2p_trust_product.id} - ${a2p_trust_product.sid}`"
                        :disabled="disableA2pTrustBundleSelection(a2p_trust_product)"
                    >
                        <label>#{{ a2p_trust_product.id }} - {{ a2p_trust_product.sid }}</label>
                        <small class="ml-2 text-dark font-weight-bold">
                            <b
                                v-if="a2p_trust_product.status"
                                class="label"
                                :class="a2p_trust_product.status | statusColor"
                            >
                                {{ a2p_trust_product.status_name }}
                            </b>
                        </small>
                    </el-option>
                </el-tooltip>
            </el-select>
            <div class="row mt-3">
                <div class="col-md-12 text-right">
                    <el-button
                        type="primary"
                        :loading="registering_a2p_brand_bundle"
                        :disabled="!selected_customer_profile_id || !selected_a2p_profile_bundle_id"
                        @click="registerA2pBrandBundle"
                    >
                        Submit
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- Stir/Shaken Dialog -->
        <el-dialog
            title="Submit Stir/Shaken Bundle"
            width="60vh"
            :visible.sync="show_register_stir_shaken_bundle_dialog"
            :before-close="handleClose"
        >
            <el-select
                v-model="selected_customer_profile_id"
                class="w-full"
                placeholder="Select customer profile "
                clearable
            >
                <el-option
                    class="p-0"
                    v-for="customer_profile in customer_profiles"
                    :key="customer_profile.id"
                    :value="customer_profile.id"
                    :label="`#${customer_profile.id} - ${customer_profile.sid}`"
                    :disabled="disableCustomerProfileSelection(customer_profile)"
                >
                    <label>#{{ customer_profile.id }} - {{ customer_profile.sid }}</label>
                    <small class="ml-2 text-dark font-weight-bold">
                        <b
                            v-if="customer_profile.status"
                            class="label"
                            :class="customer_profile.status | statusColor"
                        >
                            {{ customer_profile.status_name }}
                        </b>
                    </small>
                </el-option>
            </el-select>
            <div class="row mt-3">
                <div class="col-md-12 text-right">
                    <el-button
                        type="primary"
                        :loading="registering_stir_shaken_bundle"
                        :disabled="!selected_customer_profile_id"
                        @click="submitStirShakenBundle"
                    >
                        Submit
                    </el-button>
                </div>
            </div>
        </el-dialog>

        <!-- Voice Integrity Dialog (handles both submission and review) -->
        <VoiceIntegrityReviewDialog
            :visible="show_voice_integrity_dialog"
            :voice_integrity_bundle_id="selected_voice_integrity_bundle_id"
            :customer_profiles="customer_profiles"
            :company="company"
            @close="handleCloseVoiceIntegrityDialog"
            @updated="handleVoiceIntegrityUpdated"
        />

        <!-- Branded Caller ID Dialog -->
        <SubmitBrandedCallerIdDialog
            :visible="show_branded_caller_id_dialog"
            :company="company"
            :voice-integrity-bundles="approved_voice_integrity_bundles"
            :bundle-id="selected_branded_caller_id_bundle_id"
            @close="handleCloseBrandedCallerIdDialog"
            @submitted="handleBrandedCallerIdSubmitted"
        />

        <!-- Toll-Free Verification Dialog -->
        <TollFreeVerificationDialog
            :visible="show_create_toll_free_verification_dialog"
            :company="company"
            :customer-profiles="customer_profiles"
            @close="closeTollFreeVerificationDialog"
            @verification-created="handleTollFreeVerificationCreated"
        />

        <!-- Toll-Free Verification Details Dialog -->
        <TollFreeVerificationDialog
            v-if="selected_toll_free_verification"
            :visible="show_toll_free_verification_details_dialog"
            :company="company"
            :customer-profiles="customer_profiles"
            :verification="selected_toll_free_verification"
            @close="closeTollFreeVerificationDetails"
            @verification-updated="handleTollFreeVerificationUpdated"
        />

        <!-- A2P Brand Review Dialog -->
        <A2pBrandReviewDialog
            v-if="selected_a2p_profile_bundle_id_for_review"
            :visible="show_brand_information_dialog"
            :a2p_profile_bundle_id="selected_a2p_profile_bundle_id_for_review"
            @close="closeA2pBrandReview"
        />

        <!-- A2P Campaign Review Dialog -->
        <A2pCampaignReviewDialog
            v-if="selected_a2p_campaign_details"
            :visible="show_a2p_campaign_details_modal"
            :campaign-details="selected_a2p_campaign_details"
            :messaging-service-id="getMessagingServiceId(selected_a2p_campaign_details)"
            @close="closeA2pCampaignReview"
            @campaign-updated="handleCampaignUpdated"
        />
    </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import {acl_mixin, form_validation_mixin} from '../../mixins'
import {STATUS_PUBLIC} from '../../constants/company'
import * as ComplianceBundleTypes from '../../constants/compliance-bundle-types'
import * as ComplianceBundleStatuses from '../../constants/compliance-bundle-statuses'
import businessTypes from '../../constants/compliance-business-types'
import businessRegistrationIdentifiers from '../../constants/compliance-business-registration-identifiers'
import businessIndustries from '../../constants/compliance-business-industries'
import businessRegionsOfOperations from '../../constants/compliance-business-regions-of-operation'
import authRepJobPositions from '../../constants/compliance-auth-rep-job-positions'
import stockExchanges from '../../constants/compliance-stock-exchanges'
import ComplianceBundleList from './compliance-bundle-list.vue'
import ComplianceBundleInformation from './compliance-bundle-information.vue'
import A2pBrandReviewDialog from './pre-vetting/a2p-brand-review-dialog'
import VoiceIntegrityReviewDialog from './pre-vetting/voice-integrity-review-dialog'
import A2pCampaignReviewDialog from './pre-vetting/a2p-campaign-review-dialog'
import TollFreeVerificationDialog from './pre-vetting/toll-free-verification-dialog'
import usStates from '../../constants/compliance-business-registration-us-states'
import caProvinces from '../../constants/compliance-business-registration-ca-provinces'
import CustomerProfileRegistrationDialog from './dialogs/customer-profile-registration-dialog'
import SubmitBrandedCallerIdDialog from './dialogs/submit-branded-caller-id-dialog'

const getCountries = () => {
    const countries = window.countriesAndTimezones.getAllCountries()

    // first exclude US & CA, and then extract only id, name fields of the countries
    const countriesArr = Object.values(countries)
        .filter(({id}) => !['US', 'CA'].includes(id))
        .map(({id, name}) => {
            return {id, name}
        })

    // add US & CA to the top and return
    return [
        {id: 'US', name: 'United States'},
        {id: 'CA', name: 'Canada'},
        ...countriesArr,
    ]
}

export default {
    name: 'ComplianceTab',
    mixins: [form_validation_mixin, acl_mixin],
    props: {
        company: {
            type: Object,
            default() {
                return {}
            },
        },
        initialFilter: {
            type: String,
            default: null,
        },
    },
    components: {
        ComplianceBundleList,
        ComplianceBundleInformation,
        A2pBrandReviewDialog,
        VoiceIntegrityReviewDialog,
        A2pCampaignReviewDialog,
        TollFreeVerificationDialog,
        CustomerProfileRegistrationDialog,
        SubmitBrandedCallerIdDialog,
    },
    data() {
        return {
            STATUS_PUBLIC,
            a2p_trust_product_option_tooltip: null,
            loading_bundles: false,
            enabling_reregistration: false,

            registering_a2p_brand_bundle: false,
            registering_a2p_trust_bundle: false,
            registering_stir_shaken_bundle: false,
            creating_toll_free_verification: false,
            show_toll_free_verification_details_dialog: false,
            selected_toll_free_verification: null,
            syncing_maintenance_addons: false,
            show_register_a2p_trust_bundle_dialog: false,
            show_register_a2p_brand_bundle_dialog: false,
            show_register_stir_shaken_bundle_dialog: false,
            show_create_toll_free_verification_dialog: false,
            show_brand_information_dialog: false,
            show_voice_integrity_dialog: false,
            selected_voice_integrity_bundle_id: null,
            show_branded_caller_id_dialog: false,
            selected_branded_caller_id_bundle_id: null,
            approved_voice_integrity_bundles: [],
            show_a2p_campaign_details_modal: false,
            selected_a2p_campaign_details: null,
            search: "",
            bundle_type_filter: ComplianceBundleTypes.CUSTOMER_PROFILE,
            pagination: {
                page: 1,
                size: 20,
                total: 0,
            },
            filterToTypeMap: {
                'customer-profile': ComplianceBundleTypes.CUSTOMER_PROFILE,
                'a2p-trust-product': ComplianceBundleTypes.A2P_TRUST_PRODUCT,
                'a2p-brand': ComplianceBundleTypes.A2P_BRAND,
                'a2p-campaigns': ComplianceBundleTypes.A2P_MESSAGING_SERVICE,
                'stir-shaken': ComplianceBundleTypes.STIR_SHAKEN,
                'voice-integrity': ComplianceBundleTypes.VOICE_INTEGRITY,
                'branded-caller-id': ComplianceBundleTypes.BRANDED_CALLER_ID,
                'cnam-bundle': ComplianceBundleTypes.CNAM_BUNDLE,
                'verified-caller-id': ComplianceBundleTypes.VERIFIED_CALLER_ID,
                'toll-free-verification': ComplianceBundleTypes.TOLL_FREE_VERIFICATION,
                'address': ComplianceBundleTypes.ADDRESS_BUNDLE,
                'regulatory-bundle': ComplianceBundleTypes.REGULATORY_BUNDLE,
                'incoming-number': ComplianceBundleTypes.INCOMING_NUMBER,
                'rcs': ComplianceBundleTypes.RCS,
            },
            typeToFilterMap: {
                [ComplianceBundleTypes.CUSTOMER_PROFILE]: 'customer-profile',
                [ComplianceBundleTypes.A2P_TRUST_PRODUCT]: 'a2p-trust-product',
                [ComplianceBundleTypes.A2P_BRAND]: 'a2p-brand',
                [ComplianceBundleTypes.A2P_MESSAGING_SERVICE]: 'a2p-campaigns',
                [ComplianceBundleTypes.STIR_SHAKEN]: 'stir-shaken',
                [ComplianceBundleTypes.VOICE_INTEGRITY]: 'voice-integrity',
                [ComplianceBundleTypes.BRANDED_CALLER_ID]: 'branded-caller-id',
                [ComplianceBundleTypes.CNAM_BUNDLE]: 'cnam-bundle',
                [ComplianceBundleTypes.VERIFIED_CALLER_ID]: 'verified-caller-id',
                [ComplianceBundleTypes.TOLL_FREE_VERIFICATION]: 'toll-free-verification',
                [ComplianceBundleTypes.ADDRESS_BUNDLE]: 'address',
                [ComplianceBundleTypes.REGULATORY_BUNDLE]: 'regulatory-bundle',
                [ComplianceBundleTypes.INCOMING_NUMBER]: 'incoming-number',
                [ComplianceBundleTypes.RCS]: 'rcs',
            },
            bundles: [],
            unregistered_incoming_numbers_count: 0,
            bundle_key: 0,
            customer_profiles: [],
            a2p_trust_products: [],
            selected_customer_profile_id: null,
            selected_a2p_profile_bundle_id: null,
            selected_a2p_profile_bundle_id_for_review: null,
            ComplianceBundleTypes,
            customerProfileRegistrationDialogFormVisible: false,
            countries: [],
            usStates,
            caProvinces,
            states: [],
            manualCountryChange: false,
            businessTypes,
            businessRegistrationIdentifiers,
            businessIndustries,
            businessRegionsOfOperations,
            authRepJobPositions,
            stockExchanges,
        }
    },
    computed: {
        ...mapState(["loading_sync_bundle"]),

        guessedBusinessIdentifier() {
            return this.businessRegistrationIdentifiers.find(identifier => identifier.country === this.company.country || identifier.country === this.company.legal_country)
        },

        showRegisterCustomerProfileButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.CUSTOMER_PROFILE
        },

        showEnableReregistrationButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.CUSTOMER_PROFILE
        },

        showRegisterA2PTrustProductButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.A2P_TRUST_PRODUCT && this.hasCustomerProfile
        },

        showRegisterA2pBrandBundleButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.A2P_BRAND && this.hasCustomerProfile
        },

        showRegisterStirShakenBundleButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.STIR_SHAKEN && this.hasCustomerProfile
        },

        showRegisterVoiceIntegrityBundleButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.VOICE_INTEGRITY && this.hasCustomerProfile
        },

        showSubmitBrandedCallerIdButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.BRANDED_CALLER_ID && this.hasApprovedVoiceIntegrity
        },

        showCreateTollFreeVerificationButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.TOLL_FREE_VERIFICATION && this.hasCustomerProfile
        },

        showSyncMaintenanceAddonsButton() {
            return this.bundle_type_filter === ComplianceBundleTypes.A2P_MESSAGING_SERVICE
        },

        hasCustomerProfile() {
            return this.customer_profiles && this.customer_profiles.some(profile => profile.status !== ComplianceBundleStatuses.STATUS_STAGED)
        },

        hasApprovedVoiceIntegrity() {
            return this.approved_voice_integrity_bundles && this.approved_voice_integrity_bundles.length > 0
        },
    },
    created() {
        // get countries
        this.countries = getCountries()

        // Set initial bundle type filter based on initial filter prop
        if (this.initialFilter && this.filterToTypeMap[this.initialFilter]) {
            this.bundle_type_filter = this.filterToTypeMap[this.initialFilter]
        }
    },
    mounted() {
        this.paginateBundles(1)
        
        // Load customer profiles for hasCustomerProfile logic and child components
        this.getCustomerProfiles()

        // Load approved voice integrity bundles for Branded Caller ID
        this.getApprovedVoiceIntegrityBundles()

        VueEvent.listen('COMPLIANCE_BUNDLE_OPERATION_DONE', (data) => {
            // refresh the bundles list if admin is watching the exact bundles of a company
            if (
                +data.company_id === +this.company.id &&
                +data.bundle_type === +this.bundle_type_filter
            ) {
                this.setCompanyBundles()
            }
        })

        VueEvent.listen('RELOAD_BUNDLES', (data) => {
            // refresh the bundles list if admin is watching the exact bundles of a company
            if (
                +data.company_id === +this.company.id &&
                +data.bundle_type === +this.bundle_type_filter
            ) {
                this.setCompanyBundles()
            }
        })
    },
    methods: {
        applySearch: _.debounce(function () {
            this.pagination.page = 1

            this.setCompanyBundles()
        }, 300),

        changedBundleTypeFilter() {
            this.pagination.page = 1
            
            // Clear bundles array to prevent rendering previous bundle type data
            this.bundles = []

            this.bundle_key++

            this.updateFilterQueryParam()

            this.setCompanyBundles()
        },

        paginateBundles(page) {
            this.pagination.page = page


            this.setCompanyBundles()
        },
        handleNumbersAssigned() {
            this.paginateBundles(1)
        },

        getCustomerProfiles() {
            axios
                .get(`/api/admin/compliance/${this.company.id}/${1}`)
                .then((res) => {
                    this.customer_profiles = res.data.bundles.data
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                })
        },

        getA2pProfileBundles(customer_profile_id) {
            axios
                .get(`/api/admin/compliance/${this.company.id}/customer-profiles/${customer_profile_id}/a2p-profile-bundles`)
                .then((res) => {
                    this.a2p_trust_products = res.data
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                })
        },

        getApprovedVoiceIntegrityBundles() {
            axios
                .get(`/api/admin/compliance/${this.company.id}/${ComplianceBundleTypes.VOICE_INTEGRITY}`)
                .then((res) => {
                    // Filter only approved Voice Integrity bundles
                    this.approved_voice_integrity_bundles = res.data.bundles.data.filter(
                        bundle => bundle.status === ComplianceBundleStatuses.STATUS_APPROVED
                    )
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                })
        },

        setCompanyBundles() {
            this.loading_bundles = true

            const params = {
                search: this.search,
                page: this.pagination.page,
                size: this.pagination.size,
            }

            axios
                .get(
                    `/api/admin/compliance/${this.company.id}/${this.bundle_type_filter}`,
                    {params}
                )
                .then(({data}) => {
                    this.bundles = data.bundles.data
                    this.unregistered_incoming_numbers_count = data.unregistered_incoming_numbers_count
                    if (+this.bundle_type_filter === ComplianceBundleTypes.A2P_MESSAGING_SERVICE) {
                        this.bundles = this.bundles.filter(
                            service => !service.friendly_name.includes('[Auto-generated]')
                        );
                    }
                    this.pagination.total = data.bundles.total || 0
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.loading_bundles = false
                    this.syncing_maintenance_addons = false
                })
        },

        updateFilterQueryParam() {
            const filterParam = this.typeToFilterMap[this.bundle_type_filter]
            if (filterParam && this.$route.query.filter !== filterParam) {
                const query = { ...this.$route.query }
                query.filter = filterParam
                this.$router.push({ query }).catch(err => {
                    // Ignore NavigationDuplicated errors
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err)
                    }
                })
            }
        },

        syncBundleRemote() {
            this.pushComplianceSyncType(this.bundle_type_filter)

            axios
                .post(
                    `/api/admin/compliance/${this.company.id}/${this.bundle_type_filter}/sync`
                )
                .then(() => {
                    this.$notify({
                        title: "Sync bundles",
                        message: "Operation is being processed...",
                        type: "success",
                        showClose: true,
                    })
                })
                .catch((err) => {
                    // handle error
                    this.pullComplianceSyncType(this.bundle_type_filter)
                    this.$root.handleErrors(err.response)
                })
        },

        toggleBundleReregistration() {
            this.enabling_reregistration = true

            axios
                .post(`/api/admin/compliance/${this.company.id}/toggle-reregistration`)
                .then(({data}) => {
                    this.company.kyc_filled = data.kyc_filled

                    if (!this.company.kyc_filled) {
                        this.$notify({
                            title: "Compliance Registration",
                            message: "Registration enabled successfully.",
                            type: "success",
                            showClose: true,
                        })
                    } else {
                        this.$notify({
                            title: "Compliance Registration",
                            message: "Registration disabled successfully.",
                            type: "success",
                            showClose: true,
                        })
                    }
                    this.$emit("enabled-reregistration")
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.enabling_reregistration = false
                })
        },



        registerA2PTrustProduct() {
            this.registering_a2p_trust_bundle = true
            axios
                .post(`/api/admin/compliance/${this.company.id}/a2p-trust-bundles/${this.selected_customer_profile_id}`, {
                    force_register: true
                })
                .then(() => {
                    this.$notify({
                        title: "A2P Trust Product Registration",
                        message: "Operation is being processed...",
                        type: "success",
                        showClose: true,
                    })
                    this.show_register_a2p_trust_bundle_dialog = false
                    this.setCompanyBundles()
                    this.clearSubmissionForm()
                })
                .catch((err) => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.registering_a2p_trust_bundle = false
                })
        },

        registerA2pBrandBundle() {
            this.registering_a2p_brand_bundle = true
            axios
                .post(`/api/admin/compliance/${this.company.id}/a2p-brands/${this.selected_a2p_profile_bundle_id}`, {
                    force_register: true
                })
                .then(() => {
                    this.$notify({
                        title: "A2P Brand Registration",
                        message: "Operation is being processed...",
                        type: "success",
                        showClose: true,
                    })
                    this.show_register_a2p_brand_bundle_dialog = false
                    this.setCompanyBundles()
                    this.clearSubmissionForm()
                })
                .catch((err) => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.registering_a2p_brand_bundle = false
                })
        },

        submitStirShakenBundle() {
            this.registering_stir_shaken_bundle = true
            axios
                .post(`/api/admin/compliance/${this.company.id}/stir-shaken-bundles/${this.selected_customer_profile_id}`, {
                    force_register: true
                })
                .then(() => {
                    this.$notify({
                        title: "STIR/SHAKEN Bundle Registration",
                        message: "Operation is being processed...",
                        type: "success",
                        showClose: true,
                    })
                    this.show_register_stir_shaken_bundle_dialog = false
                    this.setCompanyBundles()
                    this.clearSubmissionForm()
                })
                .catch((err) => {
                    console.log(err)
                    this.$root.handleErrors(err.response)
                })
                .finally(() => {
                    this.registering_stir_shaken_bundle = false
                })
        },

        openRegisterA2pBrandBundleDialog() {
            this.show_register_a2p_brand_bundle_dialog = true
        },

        openregisterA2PTrustProductDialog() {
            this.show_register_a2p_trust_bundle_dialog = true
        },

        openRegisterStirShakenBundleDialog() {
            this.show_register_stir_shaken_bundle_dialog = true
        },

        openRegisterVoiceIntegrityBundleDialog() {
            // Set bundle_id to null for new submission mode
            this.selected_voice_integrity_bundle_id = null
            this.show_voice_integrity_dialog = true
        },

        openSubmitBrandedCallerIdDialog() {
            this.selected_branded_caller_id_bundle_id = null
            this.show_branded_caller_id_dialog = true
        },

        openCreateTollFreeVerificationDialog() {
            this.show_create_toll_free_verification_dialog = true
        },

        handleTollFreeVerificationCreated() {
            this.show_create_toll_free_verification_dialog = false
            this.setCompanyBundles()
        },

        syncMaintenanceAddons() {
            this.syncing_maintenance_addons = true

            axios
                .post(`/api/admin/compliance/${this.company.id}/sync-maintenance-addons`)
                .then(() => {
                    this.$notify({
                        title: "Sync Maintenance Addons",
                        message: "Operation is being processed...",
                        type: "success",
                        showClose: true,
                    })
                })
                .catch((err) => {
                    this.$root.handleErrors(err.response)
                    this.syncing_maintenance_addons = false
                })
        },

        disableCustomerProfileSelection(customer_profile) {
            return customer_profile.status === ComplianceBundleStatuses.STATUS_STAGED
        },

        disableA2pTrustBundleSelection(a2p_trust_product) {
            if (a2p_trust_product.status === ComplianceBundleStatuses.STATUS_STAGED) {
                this.a2p_trust_product_option_tooltip = 'Staged Products cannot be used.'
                return true
            }

            if (a2p_trust_product.status === ComplianceBundleStatuses.STATUS_REJECTED) {
                this.a2p_trust_product_option_tooltip = 'Rejected Products cannot be used.'
                return true
            }

            if (a2p_trust_product?.a2p_brand) {
                this.a2p_trust_product_option_tooltip = 'This Product is already associated with an A2P Brand (even if deleted).'
                return true
            }

            return false
        },

        clearSubmissionForm() {
            this.selected_customer_profile_id = null
            this.selected_a2p_profile_bundle_id = null
        },

        handleClose() {
            this.show_register_a2p_brand_bundle_dialog = false
            this.show_register_a2p_trust_bundle_dialog = false
            this.show_register_stir_shaken_bundle_dialog = false
            this.show_create_toll_free_verification_dialog = false
            this.clearSubmissionForm()
        },

        handleCloseVoiceIntegrityDialog() {
            this.show_voice_integrity_dialog = false
            this.selected_voice_integrity_bundle_id = null
        },

        handleCloseBrandedCallerIdDialog() {
            this.show_branded_caller_id_dialog = false
            this.selected_branded_caller_id_bundle_id = null
        },

        handleBrandedCallerIdSubmitted() {
            this.show_branded_caller_id_dialog = false
            this.setCompanyBundles()
        },

        onClickCustomerProfileRegistration() {
            this.customerProfileRegistrationDialogFormVisible = true
        },
        
        handleCustomerProfileRegistered() {
            this.customerProfileRegistrationDialogFormVisible = false
            this.setCompanyBundles()
        },
        
        closeCustomerProfileRegistrationDialog() {
            this.customerProfileRegistrationDialogFormVisible = false
        },

        ...mapActions(["pushComplianceSyncType", "pullComplianceSyncType"]),



        handleViewDetails(bundle) {
            // Different handling based on bundle type
            if (this.bundle_type_filter === ComplianceBundleTypes.A2P_TRUST_PRODUCT) {
                // For A2P Trust Bundle, this opens brand review dialog
                this.selected_a2p_profile_bundle_id_for_review = bundle.id
                this.show_brand_information_dialog = true
            } else if (this.bundle_type_filter === ComplianceBundleTypes.A2P_MESSAGING_SERVICE) {
                // For A2P Campaign, open campaign details modal
                this.selected_a2p_campaign_details = bundle
                this.show_a2p_campaign_details_modal = true
            } else if (this.bundle_type_filter === ComplianceBundleTypes.TOLL_FREE_VERIFICATION) {
                this.selected_toll_free_verification = bundle
                this.show_toll_free_verification_details_dialog = true
            } else if (this.bundle_type_filter === ComplianceBundleTypes.VOICE_INTEGRITY) {
                // For Voice Integrity Bundle, open review dialog with bundle ID
                this.selected_voice_integrity_bundle_id = bundle.id
                this.show_voice_integrity_dialog = true
            } else if (this.bundle_type_filter === ComplianceBundleTypes.BRANDED_CALLER_ID) {
                // For Branded Caller ID, open the same dialog in view mode
                this.selected_branded_caller_id_bundle_id = bundle.id
                this.show_branded_caller_id_dialog = true
            }
        },

        closeA2pBrandReview() {
            this.selected_a2p_profile_bundle_id_for_review = null
            this.show_brand_information_dialog = false
        },

        handleVoiceIntegrityUpdated() {
            this.show_voice_integrity_dialog = false
            this.selected_voice_integrity_bundle_id = null
            this.setCompanyBundles()
        },

        closeA2pCampaignReview() {
            this.selected_a2p_campaign_details = null
            this.show_a2p_campaign_details_modal = false
        },

        handleCampaignUpdated() {
            this.setCompanyBundles() // Refresh the bundles
        },

        getMessagingServiceId(campaignDetails) {
            return campaignDetails?.messaging_service_id || campaignDetails?.id
        },

        closeTollFreeVerificationDialog() {
            this.show_create_toll_free_verification_dialog = false;
        },

        closeTollFreeVerificationDetails() {
            this.show_toll_free_verification_details_dialog = false
            this.selected_toll_free_verification = null
        },

        handleTollFreeVerificationUpdated() {
            this.show_toll_free_verification_details_dialog = false
            this.selected_toll_free_verification = null
            this.setCompanyBundles()
        },
    },
    watch: {
        bundle_type_filter() {
            this.setCompanyBundles();
        },
        initialFilter(newFilter) {
            if (newFilter && this.filterToTypeMap[newFilter]) {
                this.bundle_type_filter = this.filterToTypeMap[newFilter]
            }
        },
    }
}
</script>
